import {
    useObtenerGraficoTotalAusenciasDashboard,
    useObtenerGraficoTotalPermisosDashboard,
    useObtenerGraficoTotalLicenciasDashboard,
    useObtenerGraficoTotalPrestamosDashboard,
    useObtenerGraficoCostoHorasExtraDashboard,
    useObtenerGraficoTasaHorasExtraDashboard,
    useObtenerGraficoTotalHorasExtraDashboard
  } from "../../Scripts/Service/rrhh-dashboard-service.js";
  
  import { SelectButton, Messages } from 'primereact';
    import React from "react";
import {useTheme} from "../../../Commons/Scripts/Hooks";
import { renderToStaticMarkup } from "react-dom/server";
import * as XLSX from "xlsx";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";
export const GraficosRRHH = () => {
    const {theme} = useTheme();
    const color = ["#3fb1e3", "#91cc75", "#fac858", "#ee6666","#73c0de","#3ba272", "#fc8452","#9a60b4","#ea7ccc"];
    const moneda = window.monedaPredeterminada;
    const labelOptions = {
      show: true,
      rotate: 90,
      align: "left",
      position: "insideBottom",
      verticalAlign: "middle",
      color: "#000",
      fontSize: 12,
    };
    const [where, setWhere] = React.useState({ where: { periodo: "mensual" } });
    const [value, setValue] = React.useState(3);
    const periodos = [
      { name: "Diario", value: 1 },
      { name: "Semanal", value: 2 },
      { name: "Mensual", value: 3 },
      { name: "Trimestral", value: 4 },
      { name: "Anual", value: 5 },
    ];
    const { data: totalAusencias } = useObtenerGraficoTotalAusenciasDashboard(where);
    const { data: totalHorasExtra } = useObtenerGraficoTotalHorasExtraDashboard(where);
    const { data: totalPermisos } = useObtenerGraficoTotalPermisosDashboard(where);
    const { data: totalLicencias } = useObtenerGraficoTotalLicenciasDashboard(where);
    const { data: totalPrestamos } = useObtenerGraficoTotalPrestamosDashboard(where);
    const { data: costoHorasExtra } = useObtenerGraficoCostoHorasExtraDashboard(where);
    const { data: tasaHorasExtra } = useObtenerGraficoTasaHorasExtraDashboard(where);

    function m(n, d) {
      //Convertir numero => 3,000,000 a 3M
      const x = Math.floor(Math.log10(Math.abs(n)));
      const suffix = ["", "k", "M", "MM", "T", "P", "E"];
      const magnitude = Math.floor(x / 3);
      const scaled = n / Math.pow(10, magnitude * 3);
      const rounded = Math.round(scaled * Math.pow(10, d)) / Math.pow(10, d);
  
      return rounded + " " + suffix[magnitude];
    }
    function handleChange(value) {
      setValue(value);
      switch (value) {
        case 1:
          setWhere({ where: { periodo: "diario" } });
          break;
        case 2:
          setWhere({ where: { periodo: "semanal" } });
          break;
        case 3:
          setWhere({ where: { periodo: "mensual" } });
          break;
        case 4:
          setWhere({ where: { periodo: "trimestral" } });
          break;
        case 5:
          setWhere({ where: { periodo: "anual" } });
          break;
      }
    }
    function crearDivGrafico(data) {
      let chartTitulo = data[0]?.Desc ?? data.Titulo;
      let dom = document.getElementById("chart_" + chartTitulo);
      if (dom) {
        var chartTemp = echarts.getInstanceByDom(
          document.getElementById("chart_" + chartTitulo)
        );
        if (chartTemp) {
          chartTemp.dispose();
        }
      } else {
        let chart = document.createElement("div");
        chart.setAttribute("id", "chart_" + chartTitulo);
        chart.setAttribute("class", "chart");
        if(chartTitulo === 'Total de Gastos' || chartTitulo === 'Tasa de Gastos' || chartTitulo?.includes("Margen") ){
          document.getElementById("chart_holder_small").appendChild(chart);
        }else{
          document.getElementById("chart_holder").appendChild(chart);
         
        }
      }
    }
    function crearGrafico(data){ 
      crearDivGrafico(data);
        const svgString = renderToStaticMarkup(<SvgComponent
            iconName="export"
            fill={theme.color1}
        />);
        const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
      var chartDom = document.getElementById('chart_' + data?.Titulo);
      const chart = echarts.init(chartDom,null,{width: '653', height: '300'} );
      var options = {
          color: color,
          title: {
              text: data.Titulo,
              left: 'center',
              textStyle: {
                  fontStyle: 'normal',
                  fontWeight: 'bolder',
                  fontFamily: 'sans-serif'
              }
          },
          legend: {
              orient: 'horizontal',
              left: 'center',
              top: 'bottom',
              show: false
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'shadow'
              },
          },
          dataset: {
              dimensions: ['periodo', 'Total'],
              source: data.Resultados.map((d) => {
                  return {
                      periodo: d.FechaDesc,
                      Total: d.Monto,
                  }
              })
          },
          toolbox: {
              show: true,
              feature: {
                  myTool1: {
                      show: true,
                      title: 'exportar',
                      icon: `image://${svgDataUrl}`,
                      onclick: function (){
                          const option = chart.getOption();
                          const source = option.dataset[0].source;
                          const dimensions = option.dataset[0].dimensions;

                          const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                          const ws = XLSX.utils.aoa_to_sheet(rows);
                          const wb = XLSX.utils.book_new();
                          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                          XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                      }
                  }
              }
          },
          xAxis: { type: 'category', },
          yAxis: {
              type: 'value',
              axisLabel: {
                  fontSize: 9,
                  formatter: function (params) {
                      if(data.Titulo?.includes("Tasa") || data.Titulo?.includes("Margen")){
                          return `${params} %`
                      }
                      else if (data.Titulo?.includes("Dias")){
                        return `${params} Dia(s)`
                      }
                      else if(data.Titulo?.includes("Permisos") || data.Titulo === "Total de Horas Extras"){
                        return `${params} Hora(s)`
                      }
                      else {
                          if(params >= 1000) return `${moneda} ${m(params,1)}`
                          else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`  
                      }                    
                  }
              },
          },
          // Declare several bar series, each will be mapped
          // to a column of dataset.source by default.
          series:
              [
                  {
                      type: 'bar',
                      emphasis: {
                          focus: 'series'
                      },
                      label: {
                          ...labelOptions,
                          formatter: function (params) {
                              if(data.Titulo.includes("Tasa") || data.Titulo.includes("Margen")){
                                  return params.value.Total.toFixed(2) + "%";
                              }
                              else if (data.Titulo?.includes("Dias")){
                                return `${params.value.Total.toFixed(2)} Dia(s)`
                              }
                              else if(data.Titulo?.includes("Permisos") || data.Titulo === "Total de Horas Extras"){
                                return `${params.value.Total.toFixed(2)} Hora(s)`
                              }
                              else {
                                  return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Total)
                              }
                          },
                      },
                      tooltip: {
                          valueFormatter: value => data.Titulo?.includes("Tasa") ?  value.toFixed(2) + "%" :
                            data.Titulo?.includes("Dias") ? value.toFixed(2) + " Dia(s)" :
                            data.Titulo?.includes("Permisos") || data.Titulo === "Total de Horas Extras" ? value.toFixed(2) + " Hora(s)"                         
                            : moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value) 
                      }
                  },
              ]
      };
      chart.setOption(options);
  }
    React.useEffect(() => {
      if (totalAusencias) {
        crearGrafico(totalAusencias);
      }
    }, [totalAusencias]);
    React.useEffect(() => {
        if (totalPermisos) {
          crearGrafico(totalPermisos);
        }
      }, [totalPermisos]);
      React.useEffect(() => {
        if (totalLicencias) {
          crearGrafico(totalLicencias);
        }
      }, [totalLicencias]);
      React.useEffect(() => {
        if (totalPrestamos) {
          crearGrafico(totalPrestamos);
        }
      }, [totalPrestamos]);
      React.useEffect(() => {
        if (costoHorasExtra) {
          crearGrafico(costoHorasExtra);
        }
      }, [costoHorasExtra]);
      React.useEffect(() => {
        if (tasaHorasExtra) {
          crearGrafico(tasaHorasExtra);
        }
      }, [tasaHorasExtra]);
      React.useEffect(() => {
        if (totalHorasExtra) {
          crearGrafico(totalHorasExtra);
        }
      }, [totalHorasExtra]);


    return (
      <div>
        <SelectButton
          value={value}
          onChange={(e) => handleChange(e.value)}
          optionLabel="name"
          options={periodos}
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "10px",
            padding: "12px",
            flexFlow: "columnWrap",
            aligItems: "center",
          }}
        />
        <div id="chart_holder_small" class="card_row"></div>
        <div id="chart_holder" class="card_row"></div>
      </div>
    );
  };
  